/*
 * El test de Tamara (guia de montaje del 24/09/2026,
 * `docs/test-guia-montaje-tamara-24-09.md`): pasa de pantalla, calcula la
 * rutina, pinta el resultado, manda los datos a Klaviyo y llena el carrito.
 *
 * Todo el marcado lo pinta el servidor (`blocks/natnatura-test*.liquid`); las
 * cadenas llegan en el JSON de `[data-nn-test-config]` o en `data-*`, asi que
 * aqui no hay castellano escrito y /pt sale en portugues.
 *
 * DOS FUNCIONES PURAS, para poder probarlas sin pagina:
 *   NNTest.rutina(entrada)             -> { rutina, tambien, resumenes }
 *   NNTest.calcularDescuento(precios, opciones) -> { tipo, pct, total, totalDesc, lineas }
 * y NNTest.montar(raiz, { modo }) monta un test, en la pagina o en la ventana
 * (`assets/natnatura-test-ventana.js`).
 *
 * EL DESCUENTO QUE SE PINTA ES EL DEL CARRITO. El codigo (10 %) y los
 * automaticos por cantidad (5/10/15 % con 2/3/4 productos) son de pedido y no
 * se suman: Shopify se queda con el mayor, y en el empate con el automatico.
 * El importe es `total − ⌊total × % / 100⌋`, medido con `/cart.js`.
 *
 * NADA EN LA URL. Nombre, edad, sexo, embarazo, objetivos y respuestas viven
 * en la memoria de la pagina. Solo con email y la casilla 1 salen hacia
 * Klaviyo (API de cliente, clave publica), y la newsletter solo con la 2.
 *
 * EL 10 % ES DE LA NEWSLETTER (Fran, 25/09). Con la casilla 1 basta para
 * recibir la rutina por email (Email 1 transaccional, sin codigo); el codigo
 * solo entra en el carrito, y solo se pinta, con la casilla 2, como en el
 * pop-up. La pantalla del email no promete el 10 % sin la casilla 2: el boton
 * lo nombra solo con ella marcada, y el «¿Quieres tu 10%?» del resultado la
 * exige.
 */
(() => {
  if (window.NNTest && window.NNTest.montar) return; // el script puede venir dos veces (pagina + ventana)

  // --- Funciones puras -------------------------------------------------------

  /**
   * La rutina: la base, el primer producto de cada objetivo en el orden de la
   * lista, y detras los productos de mas (Entreno «las dos cosas»). Sin
   * repetir; con embarazo = si, fuera los de `ocultar`. Se corta en `limite`
   * y lo que sobra va a «tambien».
   * El resumen es el trozo de cada OBJETIVO (literal del PDF), no el de la
   * respuesta: la respuesta decide el producto (Entreno) o la frase (Piel).
   * entrada = { base: {handle, rotulo, frase}, objetivos: [{ producto, frase,
   *   rotulo, resumen, respuesta: { productos: [], frases: [], frase } }],
   *   embarazo, ocultar: [], limite, valido: (handle) => bool }
   */
  const rutina = (entrada) => {
    const lista = [];
    const extras = [];
    const esta = (h) => lista.some((p) => p.handle === h) || extras.some((p) => p.handle === h);
    if (entrada.base && entrada.base.handle) {
      lista.push({ handle: entrada.base.handle, rotulo: entrada.base.rotulo || '', frase: entrada.base.frase || '' });
    }
    const resumenes = [];
    (entrada.objetivos || []).forEach((o) => {
      const r = o.respuesta || {};
      const propios = (r.productos || []).filter(Boolean);
      const prods = propios.length ? propios : [o.producto].filter(Boolean);
      prods.forEach((h, k) => {
        let frase = o.frase || '';
        if (propios.length) frase = (r.frases || [])[k] || o.frase || '';
        else if (r.frase) frase = r.frase;
        const item = { handle: h, rotulo: o.rotulo || '', frase };
        if (k === 0) {
          if (lista.some((p) => p.handle === h)) return;
          const i = extras.findIndex((p) => p.handle === h);
          if (i >= 0) extras.splice(i, 1);
          lista.push(item);
        } else if (!esta(h)) {
          extras.push(item);
        }
      });
      if (o.resumen) resumenes.push(o.resumen);
    });
    let todo = lista.concat(extras);
    // Lo que no esta en el catalogo o esta agotado sale antes de cortar, para
    // que su hueco lo ocupe el siguiente candidato y no «tambien».
    if (typeof entrada.valido === 'function') todo = todo.filter((p) => entrada.valido(p.handle));
    if (entrada.embarazo === 'si' && entrada.ocultar && entrada.ocultar.length) {
      todo = todo.filter((p) => !entrada.ocultar.includes(p.handle));
    }
    const limite = Number(entrada.limite) || 4;
    return { rutina: todo.slice(0, limite), tambien: todo.slice(limite), resumenes };
  };

  /**
   * El descuento que aplicara el carrito a la rutina (precios en centimos).
   * El tramo por cantidad es automatico: sale tambien SIN codigo (resultado
   * «sin descuento»), y cuenta las unidades de todo el carrito (`previas`,
   * lo que ya habia). Con codigo: el mayor entre el del codigo y el tramo; en
   * el empate, el tramo, que es lo que hace Shopify con dos descuentos de
   * pedido que no se combinan.
   * `otro`: el porcentaje de otro codigo que ya este en el carrito (el
   * 20NATNEWS de la ficha); si es mayor, gana el (tipo `otro`).
   * opciones = { conCodigo, porcentaje, tramos: { 2: 5, 3: 10, 4: 15 }, previas, otro }
   */
  const calcularDescuento = (precios, opciones) => {
    const n = precios.length + (Number(opciones.previas) || 0);
    const total = precios.reduce((s, p) => s + p, 0);
    const tramos = opciones.tramos || {};
    const claves = Object.keys(tramos).map(Number).filter((k) => k <= n);
    const tramo = claves.length ? Number(tramos[Math.max(...claves)]) || 0 : 0;
    const codigo = opciones.conCodigo ? Number(opciones.porcentaje) || 0 : 0;
    let tipo = null;
    let pct = 0;
    if (tramo > 0 && tramo >= codigo) {
      tipo = 'tramo';
      pct = tramo;
    } else if (codigo > 0) {
      tipo = 'codigo';
      pct = codigo;
    }
    const otro = Number(opciones.otro) || 0;
    if (otro > pct) {
      tipo = 'otro';
      pct = otro;
    }
    // El carrito descuenta ⌊total × % / 100⌋ del pedido (medido con /cart.js
    // el 24/09 con 2, 3 y 4 productos) y no lo reparte por linea. Las tarjetas
    // reparten ese mismo importe: el suelo de cada una y los centimos que
    // sobran a las de mayor resto, para que su suma sea el total pintado.
    const descuento = Math.floor((total * pct) / 100);
    const partes = precios.map((c, i) => ({ i, suelo: Math.floor((c * pct) / 100), resto: (c * pct) % 100 }));
    let sobra = descuento - partes.reduce((s, x) => s + x.suelo, 0);
    [...partes].sort((a, b) => b.resto - a.resto || a.i - b.i).forEach((x) => {
      if (sobra > 0) {
        x.suelo += 1;
        sobra -= 1;
      }
    });
    // `mejora`: lo que el email anadiria sobre lo que ya da el carrito.
    const mejora = Math.max(0, (Number(opciones.porcentaje) || 0) - Math.max(tramo, otro));
    return { tipo, pct, n, mejora, total, totalDesc: total - descuento, lineas: precios.map((c, i) => c - partes[i].suelo) };
  };

  // --- Utilidades -------------------------------------------------------------

  const formatoDinero = (centimos, formato) => {
    const conSeparadores = (valor, decimales, miles, coma) => {
      const fijo = (valor / 100).toFixed(decimales);
      const [entero, dec] = fijo.split('.');
      const e = entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return dec ? `${e}${coma}${dec}` : e;
    };
    const f = formato || '{{amount_with_comma_separator}} €';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, clave) => {
      switch (clave) {
        case 'amount':
          return conSeparadores(centimos, 2, ',', '.');
        case 'amount_no_decimals':
          return conSeparadores(centimos, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator':
          return conSeparadores(centimos, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return conSeparadores(centimos, 2, "'", '.');
        case 'amount_with_comma_separator':
        default:
          return conSeparadores(centimos, 2, '.', ',');
      }
    });
  };

  const rellenar = (texto, datos) =>
    String(texto || '').replace(/\[(\w+)\]/g, (todo, clave) => (clave in datos ? String(datos[clave]) : todo));

  const unir = (trozos, y) => {
    if (trozos.length <= 1) return trozos.join('');
    return `${trozos.slice(0, -1).join(', ')}${y}${trozos[trozos.length - 1]}`;
  };

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const enTemporada = (nodo, hoy) => {
    const t = nodo.dataset.temporada || 'siempre';
    if (t === 'nunca') return false;
    if (t !== 'automatico') return true;
    const mes = hoy.getMonth() + 1;
    const desde = Number(nodo.dataset.desde) || 1;
    const hasta = Number(nodo.dataset.hasta) || 12;
    return desde <= hasta ? mes >= desde && mes <= hasta : mes >= desde || mes <= hasta;
  };

  const rutaCarrito = (raiz, ruta) => `${raiz.endsWith('/') ? raiz : `${raiz}/`}${ruta}`;

  // --- El montaje ---------------------------------------------------------------

  const montar = (raiz, opciones = {}) => {
    if (!raiz || raiz.dataset.nnMontado) return;
    const nodoConfig = raiz.querySelector('[data-nn-test-config]');
    if (!nodoConfig) return;
    raiz.dataset.nnMontado = 'si';
    const C = JSON.parse(nodoConfig.textContent);
    // Campaña del 13 al 21/10/2026 con los descuentos por cantidad apagados
    // (ver snippets/natnatura-campana): sin tramos, el resultado no promete
    // «Por llevar 4 productos, se te aplica un −15%» que el carrito no daria.
    if (document.documentElement.hasAttribute('data-nn-campana-sin-cantidad')) C.tramos = {};
    // En campaña el 10 % de bienvenida no existe (10NATNEWS empieza el 22/10):
    // la newsletter da el 5 % extra del codigo de suscriptor (VIP5). Se cambia
    // aqui, al montar, por la misma razon que el interruptor decide en el
    // navegador: la pagina sale de la cache de Shopify (09/10/2026).
    if (document.documentElement.hasAttribute('data-nn-campana') && C.campana && C.campana.codigo) {
      C.codigo = C.campana.codigo;
      C.porcentaje = C.campana.porcentaje;
      Object.entries(C.campana.textos || {}).forEach(([k, v]) => {
        if (v) C.textos[k] = v;
      });
      const valor = raiz.querySelector('[data-codigo]');
      if (valor) valor.textContent = C.codigo;
    }
    const T = C.textos;
    const modo = opciones.modo || 'pagina';

    const pantallas = [...raiz.querySelectorAll('[data-pantalla]')];
    const pantalla = (n) => pantallas.find((p) => p.dataset.pantalla === n);
    const objetivos = [...raiz.querySelectorAll('.nn-test-objetivo')];
    const atras = raiz.querySelector('[data-atras]');
    const progreso = raiz.querySelector('[data-progreso]');
    const repetir = raiz.querySelector('[data-repetir]');
    const anuncio = raiz.querySelector('[data-anuncio]');

    // Defensas y cualquier otro objetivo de temporada: se decide con la fecha
    // del navegador (la pagina se sirve de cache: Liquid no sirve para esto).
    const hoy = opciones.hoy || new Date();
    objetivos.forEach((o) => {
      if (enTemporada(o, hoy)) o.removeAttribute('data-fuera-de-temporada');
      else o.setAttribute('data-fuera-de-temporada', '');
    });
    const disponibles = () => objetivos.filter((o) => !o.hasAttribute('data-fuera-de-temporada'));

    // La banda de cierre con foto («¿Quieres verlos todos?», Regla 8.4) es
    // una seccion aparte de la pagina: se localiza por su ancla y se ensena
    // solo en el resultado. En la ventana no esta.
    const cierre = modo === 'pagina' ? document.getElementById('cierre-test') : null;
    const seccionCierre = cierre ? cierre.closest('.shopify-section') || cierre : null;

    const estado = {
      vista: 'portada',
      nombre: '',
      edad: '',
      sexo: '',
      embarazo: '',
      elegidos: [], // nodos de objetivo, en el orden de la lista
      confirmados: false,
      pregunta: 0,
      respuestas: new Map(), // objetivo -> boton de opcion
      historial: [],
      conDescuento: false,
      email: '',
      newsletter: false,
      enviado: false, // el correo de la rutina salio hacia Klaviyo (casilla 1)
      previas: 0, // unidades de compra unica que ya habia en el carrito
      codigoEnCarrito: false, // el codigo del test ya esta puesto (email de otra vuelta)
      otro: 0, // % de otro codigo del carrito
      yendoAlEmail: false, // leyendo el carrito antes de ensenar el email
    };

    const textoSegunSexo = (el) => {
      const d = el.dataset;
      if (estado.sexo === 'hombre' && d.textoHombre) return d.textoHombre;
      if (estado.sexo === 'no-dice' && d.textoNeutro) return d.textoNeutro;
      return d.texto || el.textContent;
    };

    const pintarTextosSexo = () => {
      raiz.querySelectorAll('[data-mejorar], [data-opcion]').forEach((b) => {
        b.textContent = textoSegunSexo(b);
      });
    };

    // --- el contador: «Pregunta k de N» ----------------------------------
    const total = () =>
      4 + (!estado.sexo || estado.sexo === 'mujer' ? 1 : 0) + (estado.confirmados ? estado.elegidos.length || 1 : 3);

    const pasoMejorar = () => 4 + (estado.sexo === 'mujer' ? 1 : 0);

    const numero = (vista) => {
      switch (vista) {
        case 'nombre':
          return 1;
        case 'edad':
          return 2;
        case 'sexo':
          return 3;
        case 'embarazo':
          return 4;
        case 'mejorar':
          return pasoMejorar();
        case 'pregunta':
          return pasoMejorar() + 1 + estado.pregunta;
        default:
          return 0;
      }
    };

    // --- los grupos de respuesta unica -----------------------------------
    const radios = (grupo) => [...grupo.querySelectorAll('[role="radio"]')];

    const marcar = (boton) => {
      const grupo = boton.closest('[role="radiogroup"]');
      if (!grupo) return;
      radios(grupo).forEach((b) => {
        const si = b === boton;
        b.setAttribute('aria-checked', si ? 'true' : 'false');
        b.tabIndex = si ? 0 : -1;
      });
    };

    const elegido = (grupo) => (grupo ? radios(grupo).find((b) => b.getAttribute('aria-checked') === 'true') : null);

    const limpiar = (grupo) => {
      if (!grupo) return;
      radios(grupo).forEach((b, i) => {
        b.setAttribute('aria-checked', 'false');
        b.tabIndex = i === 0 ? 0 : -1;
      });
    };

    const grupoDe = (vista) => {
      if (vista === 'pregunta') {
        const o = estado.elegidos[estado.pregunta];
        return o ? o.querySelector('[role="radiogroup"]') : null;
      }
      const p = pantalla(vista);
      return p ? p.querySelector('[role="radiogroup"]') : null;
    };

    // --- «Siguiente» ------------------------------------------------------
    const botonSiguiente = (vista) => {
      const p = pantalla(vista === 'pregunta' ? 'mejorar' : vista);
      return p ? p.querySelector('.nn-test__acciones [data-siguiente]') : null;
    };

    const actualizarSiguiente = () => {
      const v = estado.vista;
      const b = botonSiguiente(v);
      if (!b) return;
      if (v === 'mejorar') {
        b.disabled = estado.elegidos.length === 0;
        b.textContent = T.siguiente;
      } else if (v === 'pregunta') {
        b.disabled = !elegido(grupoDe('pregunta'));
        b.textContent = estado.pregunta === estado.elegidos.length - 1 ? T.ultimo : T.siguiente;
      } else {
        b.disabled = !elegido(grupoDe(v));
      }
    };

    // --- «¿Que te gustaria mejorar?»: de 1 a 3 ----------------------------
    const pintarMejorar = () => {
      const lleno = estado.elegidos.length >= 3;
      disponibles().forEach((o) => {
        const b = o.querySelector('[data-mejorar]');
        const si = estado.elegidos.includes(o);
        b.setAttribute('aria-pressed', si ? 'true' : 'false');
        const off = lleno && !si;
        b.disabled = off;
        if (off) b.setAttribute('aria-disabled', 'true');
        else b.removeAttribute('aria-disabled');
      });
      const contador = raiz.querySelector('[data-contador]');
      if (contador) contador.textContent = rellenar(T.contador, { n: estado.elegidos.length });
    };

    // --- la barra: el contador y el filete de progreso ---------------------
    // Aparte de `ir`, porque «Pregunta k de N» cambia sin cambiar de pantalla:
    // al volver con «Atras» a «¿Que te gustaria mejorar?» (ya confirmados), N
    // cuenta los objetivos elegidos, y marcar o desmarcar uno lo mueve.
    const pintarBarra = (vista, avisar = true) => {
      const k = numero(vista);
      const n = total();
      let texto = '';
      let fraccion = 0;
      if (k) {
        texto = rellenar(T.preguntaDe, { k, total: n });
        fraccion = k / n;
      } else if (vista === 'email') {
        texto = T.ultimoPaso;
        fraccion = 1;
      } else if (vista === 'resultado') {
        fraccion = 1;
      }
      progreso.textContent = texto;
      raiz.style.setProperty('--nn-progreso', String(fraccion));
      if (anuncio && avisar) anuncio.textContent = texto;
    };

    // --- pasar de pantalla ------------------------------------------------
    const PANTALLA = { pregunta: 'mejorar' };

    let pasos = 0; // cuantas veces se ha cambiado de pantalla (para lo asincrono)
    const ir = (vista, { sinHistorial = false } = {}) => {
      pasos += 1;
      if (!sinHistorial && estado.vista && estado.vista !== 'resultado') {
        estado.historial.push({ vista: estado.vista, pregunta: estado.pregunta });
      }
      estado.vista = vista;
      raiz.dataset.estado = vista;
      if (seccionCierre) seccionCierre.style.display = vista === 'resultado' ? '' : 'none';
      const activa = PANTALLA[vista] || vista;
      pantallas.forEach((p) => {
        p.hidden = p.dataset.pantalla !== activa;
      });

      objetivos.forEach((o) =>
        o.classList.toggle('nn-test-objetivo--activo', vista === 'pregunta' && o === estado.elegidos[estado.pregunta]),
      );

      if (vista === 'edad') {
        const saludo = raiz.querySelector('[data-saludo-edad]');
        if (saludo) saludo.textContent = rellenar(T.edadSaludo, { nombre: estado.nombre });
      }
      if (vista === 'email') {
        const t = raiz.querySelector('[data-titulo-email]');
        if (t) t.textContent = rellenar(T.emailTitulo, { nombre: estado.nombre });
      }
      if (vista === 'mejorar' || vista === 'pregunta') pintarTextosSexo();
      if (vista === 'mejorar') pintarMejorar();

      pintarBarra(vista);
      atras.hidden = vista === 'portada' || vista === 'resultado';
      repetir.hidden = vista !== 'resultado';

      actualizarSiguiente();

      // Foco al titulo de la pantalla, y la pantalla a la vista.
      let titulo;
      if (vista === 'pregunta') {
        const o = estado.elegidos[estado.pregunta];
        titulo = o && o.querySelector('.nn-test__titulo');
      } else {
        const p = pantalla(activa);
        titulo = p && p.querySelector('.nn-test__titulo');
      }
      const caja = raiz.closest('[data-nn-test-scroll]');
      if (caja) caja.scrollTo({ top: 0, behavior: 'instant' });
      else if (raiz.getBoundingClientRect().top < 0) raiz.scrollIntoView({ block: 'start', behavior: 'instant' });
      if (titulo) titulo.focus({ preventScroll: true });
    };

    const volver = () => {
      const previa = estado.historial.pop();
      if (!previa) return;
      estado.pregunta = previa.pregunta;
      ir(previa.vista, { sinHistorial: true });
    };

    // --- el resultado -----------------------------------------------------
    const plantillaDe = (h) => raiz.querySelector(`template[data-nn-producto="${CSS.escape(h)}"]`);

    const calculo = (conCodigo = estado.conDescuento || estado.codigoEnCarrito) => {
      const objs = estado.elegidos.map((o) => {
        const r = estado.respuestas.get(o);
        const d = r ? r.dataset : {};
        return {
          producto: o.dataset.producto,
          frase: o.dataset.frase,
          rotulo: o.dataset.rotulo,
          resumen: o.dataset.resumen,
          respuesta: {
            productos: (d.productos || '').split(',').filter(Boolean),
            frases: [d.frase, d['frase-2'], d['frase-3']],
            frase: d.frase,
          },
        };
      });
      const r = rutina({
        base: C.base,
        objetivos: objs,
        embarazo: estado.embarazo,
        ocultar: (C.ocultarEmbarazo || '').split(',').filter(Boolean),
        limite: C.limite,
        // Solo lo que existe en el catalogo y se puede comprar: un producto
        // archivado no se pinta y uno agotado haria fallar el add.js entero.
        valido: (h) => {
          const t = plantillaDe(h);
          return Boolean(t) && t.dataset.disponible !== 'false';
        },
      });
      r.rutina.forEach((p) => {
        const t = plantillaDe(p.handle).dataset;
        p.variante = t.variante;
        p.precio = Number(t.precio) || 0;
        p.titulo = t.titulo;
        p.url = t.url;
        p.imagen = t.imagen;
      });
      const d = calcularDescuento(
        r.rutina.map((p) => p.precio),
        { conCodigo, porcentaje: C.porcentaje, tramos: C.tramos, previas: estado.previas, otro: estado.otro },
      );
      r.rutina.forEach((p, i) => {
        p.precioDesc = d.lineas[i];
      });
      return { ...r, descuento: d };
    };

    const dinero = (c) => formatoDinero(c, C.moneda && C.moneda.formato);

    /**
     * Lo que ya hay en el carrito y cambia el descuento: las unidades de
     * compra unica (suben el tramo; las de suscripcion no cuentan, los
     * automaticos tienen `appliesOnSubscription: false`), si el codigo del
     * test ya esta puesto, y el porcentaje de otro codigo de pedido.
     */
    /** Los codigos del aviso de la newsletter y su porcentaje: { codigo: % }. */
    const codigosConocidos = () => {
      const m = {};
      document.querySelectorAll('dialog.nn-captacion').forEach((d) => {
        [
          ['1', d.getAttribute('data-descuento')],
          ['2', d.getAttribute('data-descuento-2')],
        ].forEach(([fase, pct]) => {
          const c = d.querySelector(`[data-nn-fase="${fase}"] .nn-captacion__codigo`);
          const k = c ? c.textContent.trim().toLowerCase() : '';
          if (k && Number(pct) > 0) m[k] = Number(pct);
        });
      });
      return m;
    };

    const leerCarrito = async () => {
      try {
        const c = await (await fetch(rutaCarrito(C.raiz || '/', 'cart.js'), { headers: { Accept: 'application/json' } })).json();
        estado.previas = (c.items || [])
          .filter((i) => !i.selling_plan_allocation)
          .reduce((s, i) => s + (Number(i.quantity) || 0), 0);
        const nuestro = String(C.codigo || '').toLowerCase();
        estado.codigoEnCarrito = (c.discount_codes || []).some((d) => String(d.code || '').toLowerCase() === nuestro);
        const otros = (c.cart_level_discount_applications || [])
          .filter((a) => a.type === 'discount_code' && a.value_type === 'percentage' && String(a.title || '').toLowerCase() !== nuestro)
          .map((a) => Number(a.value) || 0);
        // Con el carrito vacio Shopify no dice cuanto vale un codigo puesto
        // (sale `applicable: false` y sin aplicacion). Los que da la tienda
        // (los del aviso de la newsletter, 10 % y 20 %) se conocen.
        if (!Number(c.item_count)) {
          const conocidos = codigosConocidos();
          (c.discount_codes || []).forEach((d) => {
            const k = String(d.code || '').toLowerCase();
            if (k !== nuestro && conocidos[k]) otros.push(conocidos[k]);
          });
        }
        estado.otro = Math.max(0, ...otros);
      } catch (e) {
        estado.previas = 0;
        estado.codigoEnCarrito = false;
        estado.otro = 0;
      }
    };

    /**
     * La pantalla del email dice lo que el email anade: si el tramo (u otro
     * codigo) ya iguala o supera al codigo, no promete el 10 %; y si sin
     * email ya hay descuento, el enlace no dice «sin descuento».
     */
    const pintarEmail = async () => {
      await leerCarrito();
      const con = calculo(true).descuento;
      const sin = calculo(estado.codigoEnCarrito).descuento;
      const noMejora = con.tipo !== 'codigo';
      const p = pantalla('email');
      const texto = p.querySelector('[data-email-texto]');
      const boton = p.querySelector('[data-email-boton]');
      const saltar = p.querySelector('[data-sin-descuento]');
      // Con el tramo (u otro codigo) el email no anade descuento: el texto no
      // lo hace depender del email. Con 2 productos, el literal del PDF.
      if (texto) {
        texto.textContent = !noMejora
          ? T.emailTexto
          : rellenar(con.tipo === 'otro' ? T.emailTextoOtro || T.emailTextoTramo : T.emailTextoTramo, { pct: con.pct, n: con.n });
      }
      estado.emailMejora = !noMejora;
      if (boton) boton.dataset.botonTramo = rellenar(T.emailBotonTramo, { pct: con.pct });
      pintarBotonEmail();
      if (saltar) saltar.textContent = sin.tipo ? T.emailSaltarTramo : T.emailSaltar;
    };

    /**
     * El boton de la pantalla del email nombra el 10 % solo si lo da: el
     * codigo mejora el carrito Y la casilla 2 (newsletter) esta marcada.
     */
    const pintarBotonEmail = () => {
      const p = pantalla('email');
      const boton = p.querySelector('[data-email-boton]');
      const news = p.querySelector('input[name="newsletter"]');
      if (!boton) return;
      boton.textContent = estado.emailMejora && news && news.checked ? T.emailBoton : boton.dataset.botonTramo || T.emailBotonTramo;
    };

    const pintarPrecio = (carta, precio, precioDesc) => {
      const caja = carta.querySelector('[ref="priceContainer"]');
      if (!caja) return;
      caja.textContent = '';
      const pieza = (clase, etiqueta, valor) => {
        const s = document.createElement('span');
        s.className = clase;
        const oculto = document.createElement('span');
        oculto.className = 'visually-hidden';
        oculto.textContent = `${etiqueta} `;
        s.append(oculto, valor);
        return s;
      };
      if (precioDesc != null && precioDesc < precio) {
        caja.append(
          pieza('price-item__group price', T.precioAhora, dinero(precioDesc)),
          pieza('price-item__group price-item--regular compare-at-price', T.precioAntes, dinero(precio)),
        );
      } else {
        const s = document.createElement('span');
        s.className = 'price-item__group price';
        s.textContent = dinero(precio);
        caja.append(s);
      }
    };

    const carta = (p, conDescuento) => {
      const t = plantillaDe(p.handle);
      const fragmento = t.content.cloneNode(true);
      const el = fragmento.firstElementChild;
      const rot = el.querySelector('[data-carta-rotulo]');
      const fr = el.querySelector('[data-carta-frase]');
      if (rot) rot.textContent = p.rotulo || '';
      if (fr) fr.textContent = p.frase || '';
      const precio = Number(t.dataset.precio) || 0;
      pintarPrecio(el, precio, conDescuento ? p.precioDesc : null);
      // El precio del test ignora el de comparacion: fuera tambien la
      // insignia «Oferta» (escondida a la vista, pero el lector la leeria).
      el.querySelectorAll('.color-custom-badge-sale').forEach((b) => (b.closest('.product-badges') || b).remove());
      return el;
    };

    let ultimo = null; // el ultimo calculo pintado (para el carrito y Klaviyo)

    const pintarResultado = () => {
      const r = calculo();
      ultimo = r;
      const d = r.descuento;
      // `con`: hay descuento en el carrito (el codigo o el tramo automatico).
      const con = Boolean(d.tipo);
      const q = (s) => raiz.querySelector(s);

      q('[data-aviso-embarazo]').hidden = estado.embarazo !== 'si';

      const aplicado = q('[data-aplicado]');
      aplicado.hidden = !con;
      aplicado.textContent = !con
        ? ''
        : d.tipo === 'tramo'
          ? rellenar(T.aplicadoTramo, { pct: d.pct, n: d.n })
          : d.tipo === 'otro'
            ? rellenar(T.aplicadoOtro, { pct: d.pct })
            : T.aplicado;

      q('[data-resultado-titulo]').textContent = rellenar(T.resultadoTitulo, { nombre: estado.nombre });
      q('[data-resultado-resumen]').textContent = rellenar(T.resultadoResumen, { resumen: unir(r.resumenes, T.y) });

      // La pista de las dos rejillas sale de la rutina (bloque, «el resultado»).
      const pant = pantalla('resultado');
      pant.style.setProperty('--nn-test-n', String(Math.max(1, Math.min(4, r.rutina.length))));
      pant.style.setProperty('--nn-test-n-2', String(Math.max(1, Math.min(2, r.rutina.length))));
      const rej = q('[data-rutina]');
      rej.replaceChildren(...r.rutina.map((p) => carta(p, con)));
      rej.style.setProperty('--nn-test-cols', String(Math.max(1, Math.min(4, r.rutina.length))));
      rej.style.setProperty('--nn-test-cols-2', String(Math.max(1, Math.min(2, r.rutina.length))));
      const tam = q('[data-tambien]');
      tam.replaceChildren(...r.tambien.map((p) => carta(p, false)));
      tam.style.setProperty('--nn-test-cols', String(Math.max(1, Math.min(4, r.tambien.length))));
      tam.style.setProperty('--nn-test-cols-2', String(Math.max(1, Math.min(2, r.tambien.length))));
      tam.hidden = r.tambien.length === 0;
      q('[data-tambien-titulo]').hidden = r.tambien.length === 0;

      // El bloque del codigo solo cuando el codigo es el que se aplica: con el
      // tramo el codigo no se suma y el carrito lo deja sin usar.
      q('[data-codigo-bloque]').hidden = d.tipo !== 'codigo';
      const antes = q('[data-total-antes]');
      const ahora = q('[data-total-ahora]');
      antes.hidden = !con;
      antes.textContent = con ? dinero(d.total) : '';
      ahora.textContent = dinero(con ? d.totalDesc : d.total);

      const rotulo = q('[data-total-rotulo]');
      const comprar = q('[data-comprar]');
      if (!con) {
        rotulo.textContent = rellenar(T.totalSin, { n: r.rutina.length });
        comprar.textContent = T.botonSin;
      } else if (d.tipo !== 'codigo') {
        rotulo.textContent = rellenar(T.totalConTramo, { pct: d.pct });
        comprar.textContent = rellenar(T.botonConTramo, { pct: d.pct });
      } else {
        rotulo.textContent = T.totalCon;
        comprar.textContent = T.botonCon;
      }
      comprar.href = enlaceCarrito(r.rutina, d.tipo === 'codigo', false);
      // «Te hemos enviado tu rutina»: con la casilla 1 basta (el correo de la
      // rutina es transaccional), sin depender de la 2 ni del descuento.
      q('[data-enviado]').hidden = !(estado.enviado && C.emails);
      // El «¿Quieres tu 10%?» lleva ya el email si lo dio sin la casilla 2.
      const campoPedir = q('[data-pedir] input[name="email"]');
      if (campoPedir && estado.email && !campoPedir.value) campoPedir.value = estado.email;
      // «¿Quieres tu 10%?» solo si el email mejora lo que ya da el carrito (y
      // no si el codigo ya esta puesto de otra vuelta del test).
      q('[data-pedir]').hidden = Boolean(estado.conDescuento || estado.codigoEnCarrito) || d.mejora <= 0;

      // La banda de cierre lleva a la coleccion del primer objetivo elegido.
      const primero = estado.elegidos.find((o) => o.dataset.url);
      if (primero) document.querySelectorAll('[data-resultado-coleccion]').forEach((a) => (a.href = primero.dataset.url));
      q('[data-error-carrito]').hidden = true;

      // Las galerias de las tarjetas se montaron fuera de la vista.
      window.dispatchEvent(new Event('resize'));
    };

    /** El enlace permanente del carrito: la reserva sin JS y el del correo. */
    const enlaceCarrito = (productos, conCodigo, absoluto) => {
      const lineas = productos.map((p) => `${p.variante}:1`).join(',');
      const consulta = conCodigo ? `?discount=${encodeURIComponent(C.codigo)}&storefront=true` : '?storefront=true';
      const ruta = rutaCarrito(C.raiz || '/', `cart/${lineas}${consulta}`);
      return absoluto ? `${window.location.origin}${ruta}` : ruta;
    };

    // --- el carrito -------------------------------------------------------
    const seccionesDelCarrito = () =>
      [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);

    const pedir = async (ruta, cuerpo) => {
      const respuesta = await fetch(rutaCarrito(C.raiz || '/', ruta), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo),
      });
      const datos = await respuesta.json();
      if (!respuesta.ok || datos.status) throw datos;
      return datos;
    };

    /** Pone el codigo en el carrito sin quitar los que ya hubiera. */
    const ponerCodigo = async (secciones) => {
      const carrito = await (await fetch(rutaCarrito(C.raiz || '/', 'cart.js'), { headers: { Accept: 'application/json' } })).json();
      const codigos = (carrito.discount_codes || []).map((d) => d.code).filter(Boolean);
      if (!codigos.some((c) => c.toLowerCase() === String(C.codigo).toLowerCase())) codigos.push(C.codigo);
      const cuerpo = { discount: codigos.join(',') };
      if (secciones && secciones.length) cuerpo.sections = secciones.join(',');
      return pedir('cart/update.js', cuerpo);
    };

    /** Avisa a Horizon como su product-form: el cajon se repinta y se abre. */
    const avisarCarrito = async (lineas, secciones, accion = 'add') => {
      const carrito = await (await fetch(rutaCarrito(C.raiz || '/', 'cart.js'), { headers: { Accept: 'application/json' } })).json();
      const detalle = { items: carrito.items, sections: secciones, didError: false, source: 'natnatura-test' };
      let evento;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        evento = new CartLinesUpdateEvent({
          action: accion,
          context: 'product',
          lines: lineas.map((p) => ({ merchandiseId: String(p.variante), quantity: Number(p.cantidad) || 1 })),
          promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: detalle }),
        });
      } catch (e) {
        evento = new Event('shopify:cart:lines-update', { bubbles: true });
        evento.action = accion;
        evento.promise = Promise.resolve({ cart: { totalQuantity: carrito.item_count }, detail: detalle });
      }
      document.dispatchEvent(evento);
    };

    /** En la ventana, la cierra y espera (devuelve el foco); en la pagina, nada. */
    const cerrarVentana = () =>
      new Promise((listo) => {
        const detalle = { listo, atendido: false };
        raiz.dispatchEvent(new CustomEvent('nn:test:cerrar', { bubbles: true, detail: detalle }));
        if (!detalle.atendido) listo();
      });

    const comprar = async (boton) => {
      if (!ultimo || boton.getAttribute('aria-busy') === 'true') return;
      const r = ultimo;
      const con = estado.conDescuento;
      const error = raiz.querySelector('[data-error-carrito]');
      error.hidden = true;
      boton.setAttribute('aria-busy', 'true');
      try {
        const secciones = seccionesDelCarrito();
        let datos = await pedir('cart/add.js', {
          items: r.rutina.map((p) => ({ id: Number(p.variante), quantity: 1 })),
          sections: secciones.join(','),
        });
        if (con) datos = await ponerCodigo(secciones);
        const htmls = datos.sections || {};
        // Primero se cierra la ventana (devuelve el foco) y luego se abre el
        // cajon: si no, Horizon espera a que se cierre un modal abierto.
        await cerrarVentana();
        await avisarCarrito(r.rutina, htmls);
      } catch (e) {
        error.textContent = (e && e.description) || T.errorCarrito;
        error.hidden = false;
      } finally {
        boton.removeAttribute('aria-busy');
      }
    };

    // --- Klaviyo (API de cliente, clave publica) --------------------------
    const klaviyo = async (ruta, datos) => {
      const k = C.klaviyo || {};
      // Sin clave publica no se manda nada: es un fallo, no un exito (si no,
      // la pantalla diria «Te hemos enviado tu rutina» sin haberla enviado).
      if (!k.empresa) throw new Error('klaviyo: sin clave publica');
      const r = await fetch(`https://a.klaviyo.com/client/${ruta}/?company_id=${encodeURIComponent(k.empresa)}`, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify({ data: datos }),
        // Que salga aunque se deje la pagina (el cajon lleva a pagar).
        keepalive: true,
      });
      if (!r.ok) throw new Error(`klaviyo ${ruta}: ${r.status}`);
    };

    /**
     * Identifica ESTE navegador en Klaviyo con el email del test. La API de
     * cliente crea el perfil, pero el navegador sigue anonimo, y los eventos
     * de klaviyo.js (el «Carrito actualizado» de la cesta, que arranca el
     * carrito abandonado) se quedaban sin dueño (06/10/2026). Si klaviyo.js
     * aun no ha cargado, espera en su cola `_klOnsite`.
     */
    const identificarEnKlaviyo = (perfil) => {
      const k = window.klaviyo;
      if (k && typeof k.identify === 'function') {
        Promise.resolve(k.identify(perfil)).catch((e) => console.warn('[natnatura-test] Klaviyo identify:', e));
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['identify', perfil]);
    };

    /**
     * Un paso de Klaviyo, esperando su respuesta. Van EN SERIE -perfil, luego
     * suscripcion, luego evento- para que la suscripcion y el evento lleguen
     * sobre el perfil ya escrito con sus propiedades (en paralelo, Klaviyo
     * podia crear el perfil desde la suscripcion antes que desde /profiles).
     * Un fallo no para los siguientes: la suscripcion es el consentimiento.
     */
    const pasoKlaviyo = async (ruta, datos) => {
      try {
        await klaviyo(ruta, datos);
        return true;
      } catch (e) {
        console.warn('[natnatura-test] Klaviyo:', e); // el resultado sale igual
        return false;
      }
    };

    /**
     * `evento: false` en el segundo envio del mismo email (el «¿Quieres tu
     * 10%?» del resultado tras mandar solo con la casilla 1): el flujo del
     * test no deja volver a entrar en 7 dias, asi que un segundo «Test
     * completado» no mandaria nada. Solo perfil y suscripcion; el codigo le
     * llega por la Bienvenida al entrar en la lista.
     */
    const enviarAKlaviyo = async ({ evento = true } = {}) => {
      const r = ultimo || calculo();
      const idioma = C.idioma || document.documentElement.lang || 'es';
      const etiquetas = estado.elegidos.map((o) => o.dataset.objetivo);
      const respuestas = {};
      estado.elegidos.forEach((o) => {
        const b = estado.respuestas.get(o);
        if (!b) return;
        const grupo = b.closest('[role="radiogroup"]');
        respuestas[o.dataset.objetivo] = { indice: radios(grupo).indexOf(b), texto: b.textContent.trim() };
      });
      // La respuesta se guarda como etiqueta (guia, pag. 7): `test-energia-2`
      // es la segunda respuesta de Energia. Por numero y no por texto, que
      // cambia con el sexo y el idioma.
      const etiquetasRespuesta = Object.entries(respuestas).map(([obj, x]) => `${obj}-${x.indice + 1}`);
      const email = estado.email;
      // Solo llega aqui con la casilla 1 marcada: el mismo consentimiento
      // que deja salir el perfil.
      identificarEnKlaviyo({ email, ...(estado.nombre ? { first_name: estado.nombre } : {}) });
      const okPerfil = await pasoKlaviyo('profiles', {
        type: 'profile',
        attributes: {
          email,
          first_name: estado.nombre,
          locale: idioma.startsWith('pt') ? 'pt-PT' : 'es-ES',
          properties: {
            origen_test: true,
            // Marca de quien se suscribe desde el test (casilla 2). Desde el
            // 25/09 la Bienvenida no la excluye: le da su 10NATNEWS.
            ...(estado.newsletter ? { test_newsletter: true } : {}),
            test_tramo_edad: estado.edad,
            test_sexo: estado.sexo,
            test_embarazo: estado.embarazo,
            test_objetivos: etiquetas,
            test_respuestas: respuestas,
            test_etiquetas: ['origen-test', ...etiquetas, ...etiquetasRespuesta],
            test_idioma: idioma,
            test_fecha: new Date().toISOString(),
          },
        },
      });
      let okSuscripcion = true;
      if (estado.newsletter && C.klaviyo.lista) {
        okSuscripcion = await pasoKlaviyo('subscriptions', {
          type: 'subscription',
          attributes: {
            custom_source: 'Test por objetivos',
            profile: {
              data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } },
            },
          },
          relationships: { list: { data: { type: 'list', id: C.klaviyo.lista } } },
        });
      }
      if (!evento) return okPerfil && okSuscripcion;
      // El correo lleva a un carrito NUEVO con solo la rutina (enlace
      // /cart/<variantes>), y sale 24 h despues: su descuento es el de la
      // rutina sola, sin lo que ya hubiera en este carrito (`previas`) ni otro
      // codigo puesto en el navegador (`otro`), que el enlace no lleva. Asi el
      // Email 2 no promete un −X % que ese carrito no aplica.
      const d = calcularDescuento(
        r.rutina.map((p) => p.precio),
        { conCodigo: estado.conDescuento, porcentaje: C.porcentaje, tramos: C.tramos, previas: 0, otro: 0 },
      );
      return pasoKlaviyo('events', {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Test completado' } } },
          profile: { data: { type: 'profile', attributes: { email, first_name: estado.nombre } } },
          unique_id: window.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`,
          value: (d.tipo ? d.totalDesc : d.total) / 100,
          properties: {
            Nombre: estado.nombre,
            Resumen: unir(r.resumenes, T.y),
            Codigo: C.codigo,
            // El descuento que aplica el carrito del enlace a la rutina: con 3
            // o 4 productos gana el tramo y no el codigo. Tipo `codigo`,
            // `tramo` o vacio (nunca `otro`: el enlace no lleva otro codigo).
            Descuento: d.pct,
            TipoDescuento: d.tipo || '',
            Idioma: idioma,
            Newsletter: estado.newsletter,
            // Con el codigo solo si es el que aplica el carrito (casilla 2 y
            // gana al tramo); RutinaURL, siempre sin codigo (Email 1).
            CarritoURL: enlaceCarrito(r.rutina, d.tipo === 'codigo', true),
            RutinaURL: enlaceCarrito(r.rutina, false, true),
            Productos: r.rutina.map((p, i) => ({
              Handle: p.handle,
              Titulo: p.titulo,
              URL: `${window.location.origin}${p.url}`,
              Imagen: !p.imagen ? '' : p.imagen.startsWith('//') ? `https:${p.imagen}` : p.imagen.startsWith('/') ? `${window.location.origin}${p.imagen}` : p.imagen,
              Rotulo: p.rotulo,
              Frase: p.frase,
              Precio: dinero(p.precio),
              PrecioDescuento: dinero(d.lineas[i]),
            })),
          },
        },
      });
    };

    // --- el email ---------------------------------------------------------
    const validar = (form) => {
      const campo = form.querySelector('input[name="email"]');
      const casilla = form.querySelector('input[name="consiento"]');
      const news = form.querySelector('input[name="newsletter"]');
      const error = form.querySelector('[data-error]');
      const valor = campo.value.trim();
      let mensaje = '';
      let malo = null;
      if (!EMAIL.test(valor)) {
        mensaje = T.errorEmail;
        malo = campo;
      } else if (!casilla.checked) {
        mensaje = T.errorCasilla;
        malo = casilla;
      } else if (form.hasAttribute('data-pide-newsletter') && news && !news.checked) {
        // «¿Quieres tu 10%?»: el 10 % es de la newsletter.
        mensaje = T.errorNewsletter;
        malo = news;
      }
      campo.setAttribute('aria-invalid', malo === campo ? 'true' : 'false');
      casilla.setAttribute('aria-invalid', malo === casilla ? 'true' : 'false');
      if (news) news.setAttribute('aria-invalid', malo === news ? 'true' : 'false');
      error.textContent = mensaje;
      error.hidden = !mensaje;
      if (malo) malo.focus();
      return !malo;
    };

    const enviarEmail = async (form) => {
      if (!validar(form)) return;
      const boton = form.querySelector('[type="submit"]');
      if (boton) boton.disabled = true;
      const email = form.querySelector('input[name="email"]').value.trim();
      // Segundo envio del mismo email con la rutina ya enviada: sin evento.
      const yaEnviado = estado.enviado && estado.email === email;
      estado.email = email;
      estado.newsletter = form.querySelector('input[name="newsletter"]').checked;
      // El 10 % solo con la casilla 2 (Fran, 25/09). Si ya lo tenia de antes
      // (otra vuelta con la 2), no se le quita.
      estado.conDescuento = estado.conDescuento || estado.newsletter;
      estado.enviado = true;
      await leerCarrito();
      ultimo = calculo();
      // No bloquea: un fallo no para el resultado, pero entonces no se dice
      // «Te hemos enviado tu rutina».
      enviarAKlaviyo({ evento: !yaEnviado }).then((ok) => {
        if (ok || yaEnviado) return;
        estado.enviado = false;
        const aviso = raiz.querySelector('[data-enviado]');
        if (aviso) aviso.hidden = true;
      });
      if (estado.newsletter) {
        try {
          // El codigo entra ya en el carrito (vacio o no), y el cajon se repinta
          // sin abrirse: «Tu 10% ya está aplicado en el carrito». El aviso a
          // Horizon lleva las lineas que hay de verdad; con el carrito vacio no
          // se lanza (un evento de lineas sin lineas no describe nada).
          const datos = await ponerCodigo(seccionesDelCarrito());
          const lineas = (datos.items || []).map((i) => ({ variante: i.variant_id, cantidad: i.quantity }));
          if (lineas.length) await avisarCarrito(lineas, datos.sections || {}, 'update');
        } catch (e) {
          console.warn('[natnatura-test] codigo:', e);
        }
      }
      if (boton) boton.disabled = false;
      pintarResultado();
      ir('resultado');
    };

    // --- reiniciar --------------------------------------------------------
    const reiniciar = () => {
      Object.assign(estado, {
        nombre: '',
        edad: '',
        sexo: '',
        embarazo: '',
        elegidos: [],
        confirmados: false,
        pregunta: 0,
        historial: [],
        conDescuento: false,
        email: '',
        newsletter: false,
        enviado: false,
        emailMejora: false,
        codigoEnCarrito: false,
        otro: 0,
        yendoAlEmail: false,
      });
      estado.respuestas = new Map();
      raiz.querySelectorAll('[role="radiogroup"]').forEach(limpiar);
      raiz.querySelectorAll('form').forEach((f) => {
        f.reset();
        f.querySelectorAll('[aria-invalid]').forEach((c) => c.removeAttribute('aria-invalid'));
        f.querySelectorAll('[data-error]').forEach((e) => {
          e.hidden = true;
        });
      });
      const nombreBoton = raiz.querySelector('[data-form-nombre] [data-siguiente]');
      if (nombreBoton) nombreBoton.disabled = true;
      ultimo = null;
    };

    // --- lo que se pulsa --------------------------------------------------
    const formNombre = raiz.querySelector('[data-form-nombre]');
    const campoNombre = formNombre.querySelector('input[name="nombre"]');
    campoNombre.addEventListener('input', () => {
      formNombre.querySelector('[data-siguiente]').disabled = campoNombre.value.trim() === '';
    });
    formNombre.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = campoNombre.value.trim().slice(0, 40);
      if (!v) return;
      estado.nombre = v;
      ir('edad');
    });

    raiz.querySelectorAll('[data-form-email]').forEach((f) => {
      f.addEventListener('submit', (e) => {
        e.preventDefault();
        enviarEmail(f);
      });
      // La casilla 2 cambia el boton de la pantalla del email (con o sin el 10 %).
      f.addEventListener('change', (e) => {
        if (e.target && e.target.name === 'newsletter') pintarBotonEmail();
      });
    });

    const avanzar = () => {
      const v = estado.vista;
      if (v === 'edad') {
        const b = elegido(grupoDe('edad'));
        if (!b) return;
        estado.edad = b.dataset.valor;
        if (estado.edad === '<18') {
          // Salida de menores: sin datos. Se borran nombre y edad (y el
          // campo); «Atras» vuelve al nombre, vacio, y de ahi a la portada.
          reiniciar();
          estado.historial = [
            { vista: 'portada', pregunta: 0 },
            { vista: 'nombre', pregunta: 0 },
          ];
          ir('menores', { sinHistorial: true });
          return;
        }
        ir('sexo');
      } else if (v === 'sexo') {
        const b = elegido(grupoDe('sexo'));
        if (!b) return;
        estado.sexo = b.dataset.valor;
        if (estado.sexo === 'mujer') ir('embarazo');
        else {
          estado.embarazo = '';
          limpiar(grupoDe('embarazo'));
          ir('mejorar');
        }
      } else if (v === 'embarazo') {
        const b = elegido(grupoDe('embarazo'));
        if (!b) return;
        estado.embarazo = b.dataset.valor;
        ir('mejorar');
      } else if (v === 'mejorar') {
        if (!estado.elegidos.length) return;
        estado.confirmados = true;
        estado.pregunta = 0;
        ir('pregunta');
      } else if (v === 'pregunta') {
        const o = estado.elegidos[estado.pregunta];
        const b = elegido(grupoDe('pregunta'));
        if (!o || !b) return;
        estado.respuestas.set(o, b);
        if (estado.pregunta + 1 < estado.elegidos.length) {
          // El historial guarda la pregunta que se deja, no a la que se va.
          estado.historial.push({ vista: 'pregunta', pregunta: estado.pregunta });
          estado.pregunta += 1;
          ir('pregunta', { sinHistorial: true });
        } else {
          // La pantalla del email lee el carrito antes de pintarse. Mientras,
          // «Siguiente» no vuelve a avanzar, y si entretanto se pulsa «Atras»
          // (o se reinicia) esta vuelta ya no lleva al email.
          if (estado.yendoAlEmail) return;
          estado.yendoAlEmail = true;
          const boton = botonSiguiente('pregunta');
          if (boton) boton.setAttribute('aria-busy', 'true');
          const desde = pasos;
          pintarEmail().finally(() => {
            estado.yendoAlEmail = false;
            if (boton) boton.removeAttribute('aria-busy');
            if (pasos === desde) ir('email');
          });
        }
      }
    };

    raiz.addEventListener('click', (e) => {
      const el = e.target.closest('button, a');
      if (!el || !raiz.contains(el)) return;

      if (el.hasAttribute('data-empezar')) {
        reiniciar();
        ir('nombre');
      } else if (el.hasAttribute('data-atras')) {
        volver();
      } else if (el.getAttribute('role') === 'radio') {
        marcar(el);
        actualizarSiguiente();
      } else if (el.hasAttribute('data-mejorar')) {
        const o = el.closest('.nn-test-objetivo');
        const i = estado.elegidos.indexOf(o);
        if (i >= 0) {
          estado.elegidos.splice(i, 1);
          // Desmarcar un objetivo borra su respuesta.
          estado.respuestas.delete(o);
          limpiar(o.querySelector('[role="radiogroup"]'));
        } else if (estado.elegidos.length < 3) {
          estado.elegidos.push(o);
          estado.elegidos.sort((a, b) => objetivos.indexOf(a) - objetivos.indexOf(b));
        }
        pintarMejorar();
        pintarBarra(estado.vista, false);
        actualizarSiguiente();
      } else if (el.hasAttribute('data-siguiente') && el.type !== 'submit') {
        avanzar();
      } else if (el.hasAttribute('data-sin-descuento')) {
        estado.conDescuento = false;
        leerCarrito().then(() => {
          pintarResultado();
          ir('resultado');
        });
      } else if (el.hasAttribute('data-repetir')) {
        reiniciar();
        estado.historial = [{ vista: 'portada', pregunta: 0 }];
        ir('nombre', { sinHistorial: true });
      } else if (el.hasAttribute('data-copiar')) {
        const aviso = raiz.querySelector('[data-copiado]');
        const hecho = () => {
          el.textContent = T.copiado;
          if (aviso) aviso.textContent = T.copiado;
          window.setTimeout(() => {
            el.textContent = T.copiar;
          }, 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(C.codigo).then(hecho, hecho);
        else hecho();
      } else if (el.hasAttribute('data-comprar')) {
        e.preventDefault();
        comprar(el);
      } else if (el.hasAttribute('data-volver') && modo === 'ventana') {
        e.preventDefault();
        cerrarVentana();
      }
    });

    // «Empezar de nuevo» de la banda de cierre: fuera de la raiz, y por
    // delegacion en `document` porque `theme dev` sustituye las secciones.
    if (cierre) {
      document.addEventListener('click', (e) => {
        const el = e.target.closest && e.target.closest('#cierre-test [data-reiniciar]');
        if (!el || !raiz.isConnected) return;
        e.preventDefault();
        reiniciar();
        estado.historial = [{ vista: 'portada', pregunta: 0 }];
        ir('nombre', { sinHistorial: true });
        raiz.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }

    // Flechas en los grupos de respuesta unica (patron radiogroup).
    raiz.addEventListener('keydown', (e) => {
      const el = e.target.closest('[role="radio"]');
      if (!el) return;
      const paso = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!paso) return;
      e.preventDefault();
      const lista = radios(el.closest('[role="radiogroup"]'));
      const siguiente = lista[(lista.indexOf(el) + paso + lista.length) % lista.length];
      marcar(siguiente);
      siguiente.focus();
      actualizarSiguiente();
    });

    // El editor de temas: al elegir un objetivo o una respuesta se ensena su pregunta.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const o = e.target.closest && e.target.closest('.nn-test-objetivo');
        if (!o || !raiz.contains(o)) return;
        if (!estado.elegidos.includes(o)) estado.elegidos = [o];
        estado.confirmados = true;
        estado.pregunta = estado.elegidos.indexOf(o);
        ir('pregunta', { sinHistorial: true });
      });
    }

    raiz.nnTest = { estado, ir, calculo, pintarResultado, reiniciar };
    ir('portada', { sinHistorial: true });
    // En la pagina la portada no se enfoca sola (le quitaria el foco a la cabecera).
    if (modo === 'pagina' && document.activeElement && raiz.contains(document.activeElement)) document.activeElement.blur();
  };

  window.NNTest = { rutina, calcularDescuento, formatoDinero, montar };

  const montarTodos = (ambito) =>
    ambito.querySelectorAll('[data-nn-test]').forEach((r) => {
      if (!r.closest('template')) montar(r, { modo: 'pagina' });
    });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => montarTodos(document));
  else montarTodos(document);
  document.addEventListener('shopify:section:load', (e) => montarTodos(e.target));
})();
